module.exports = "\n<div [style.backgroundColor]=\"color\" class=\"amp-color-preview__color\"></div>\n"